export function getAirbalticApiUrl(path: string) {
  const runtimeConfig = useRuntimeConfig()
  return `${runtimeConfig.public.airbalticApiUrl}${path}`
}

export function getAirbalticBlogLatestFeedApiUrl(lang: string) {
  const runtimeConfig = useRuntimeConfig()
  return `${runtimeConfig.public.blogUrl}/${lang}wp-json/wp/v2/latest-feed`
}
